import React from "react";

const DataPLIS = () => {
  return (
    <div style={{ width: "100%", height: "600px" }}>
      <iframe
      src="/plis/index.html"
      style={{ width: "100%", height: "100vh", border: "none" }}
      title="PLIS Dashboard"
    />
    </div>
  );
};

export default DataPLIS;
